import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_THING, THINGS } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
  parentId: {
    label: 'Parent',
    blank: 'null',
  },
  emoji: {
    label: 'Emoji',
    rules: {
      pattern: {
        value: /^[\p{Emoji}\w]{0,1}$/u,
        message: 'Only one emoji or letter allowed',
      },
    },
  },
};

const NewThing = () => {
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data: selects } = useQuery(THINGS);

  const [createThing] = useMutation(CREATE_THING, {
    onCompleted: () => navigate('/things'),
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    createThing({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.parentId.select = [
      { value: '', label: 'NONE' },
      ...selects.things
        .map(entry => ({ value: entry.id, label: entry.name }))
    ];
  }

  return (
    <View>
      <Title>Add Thing</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewThing;
